import {useMaterials, MaterialType} from '@domain/materials'

import {useUrlParam} from '../../../routing'

export const useMaterialsQuery = (materialType?: MaterialType) => {
  const plantCode = useUrlParam('plantCode')
  return useMaterials({
    plantCode,
    options: {
      select: (materials) =>
        materials
          .filter((material) => (materialType ? material.type === materialType : true))
          .sort((a, b) => a.name.localeCompare(b.name))
    }
  })
}
